import { Component, Input, OnInit } from '@angular/core';
import { Tenant } from 'src/app/shared/models/tenant';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

@Component({
  selector: 'app-member-logo-name',
  templateUrl: './member-logo-name.component.html',
  styleUrls: ['./member-logo-name.component.scss'],
  standalone: false
})
export class MemberLogoNameComponent implements OnInit {
  @Input()
  logoUrl: string;
  tenant: Tenant;
  constructor(private appConfigService: AppConfigService) {}
  ngOnInit(): void {
    this.tenant = this.appConfigService.tenant;
  }
}
